<template>
  <div class="page_israGud">
    <div class="topOperation">
      <div class="top-left">
        <ShowNavHead />
      </div>
    </div>
    <div class="main-con">
      <div class="crumbs">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>业务指南</el-breadcrumb-item>
          <el-breadcrumb-item>资料模板</el-breadcrumb-item>
          <el-breadcrumb-item>报价指导</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="ftabs">
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="案例管理" name="/successCaseSet"></el-tab-pane>
          <el-tab-pane label="合同模板管理" name="/contractTemplateSet"></el-tab-pane>
          <el-tab-pane label="报价体系" name="/quotationGuiSet"></el-tab-pane>
          <!-- <el-tab-pane label="三体系认证" name="/threeSystem"></el-tab-pane> -->
          <el-tab-pane label="公司介绍" name="/companyProfileSet"></el-tab-pane>
        </el-tabs>
        <div class="flex">
          <el-upload class="table_upload" action="" :on-change="(file, fileList) => {handleChangeUpload(file, fileList)}" accept=".pdf" :auto-upload="false" :show-file-list="false" :multiple="false">
            <el-button v-preventReClick type="primary" size="small">上传</el-button>
          </el-upload>
          <el-button v-preventReClick @click="onDownloadFile" type="success" size="small" style="margin-left: 15px;">下载</el-button>
        </div>
        <pdf v-if="pdfSrc" :src="headPath + pdfSrc" :page="1" style="width:100%" ref="pdf"></pdf>
        <div v-else>
          <el-empty description="暂未上传报价指导"></el-empty>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import xz from "../../common";
  import pdf from 'vue-pdf' //引入下载的vue-pdf
  import {
    download
  } from '@/utils' //封装的下载方法
  export default {
    components: {
      pdf
    },
    data() {
      return {
        headPath: this.$store.state.EMP.docPath,
        pdfSrc: '',
        listQuery: {
          BusinessId: '报价指导',
          pageNum: 1,
          pageSize: "10"
        },
        tableData: [],
        activeName:'/quotationGuiSet'
      };
    },
    created() {
      this.getfilelist()
    },
    methods: {
      //获取保洁指导
      getfilelist() {
        xz.getfilelist(this.listQuery).then(res => {
          if (res.status == 'ok' && res.data.data.length > 0) {
            this.pdfSrc = res.data.data[0].Url;
            this.tableData = res.data.data;
          } else {
            this.pdfSrc = ''
          }
        })
      },
      handleClick(){
        this.$router.push({
          path:this.activeName
        })
      },
      //上传
      handleChangeUpload(file, fileList) {
        let formData = new FormData();
        formData.append("action", "save");
        formData.append("pagename", "bdocinf");
        formData.append("userid", Cookies.get("userid-b"));
        formData.append("entid", Cookies.get("userid-b"));
        formData.append("entPicFile", file.raw, file.raw.name);
        xz.uploadCert(formData).then((res) => {
          if (res) {
            let data;
            if (this.tableData.length == 0) {
              data = {
                Id: '',
                BusinessId: '报价指导',
                Url: res,
                FileType: '报价指导'
              }
            } else {
              this.tableData[0].Url = res;
              data = this.tableData[0]
            }
            xz.updatefilemanage(data).then(res => {
              if (res.status == 'ok') {
                this.getfilelist();
                this.$message.success('保存成功！')
              } else {
                this.$message.error('系统出错')
              }
            })
          } else {
            this.$message("文件上传失败,请稍后再试");
          }
        });
      },
      //下载pdf
      onDownloadFile() {
        download(this.headPath + this.pdfSrc)
      }
    }
  };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .ftabs {
    background: #fff;
    padding: 10px 16px 16px;
    width: 98%;
    margin-bottom: 16px;
  }

  .info_item_sys {
    color: #598DE7;
  }
</style>
<style>

</style>